<template>
  <section class="container" id="skills">
    <div class="section-2">
      <div class="introduction">
        <h4>Skills</h4>
        <p>
          In my role as a Full Stack Engineer, I've meticulously cultivated a
          comprehensive skill set, arming myself to proficiently tackle a wide
          spectrum of development challenges and seize opportunities in this
          dynamic digital landscape. The following is a glimpse of the key
          skills I frequently employ, leveraging them to breathe life into
          exciting web projects and innovations.
        </p>
        <div class="skills-container">
          <p>JavaScript ES6</p>
          <p>TypeScript</p>
          <p>Material UI</p>
          <p>Tailwind</p>
          <p>React</p>
          <p>Next.js</p>
          <p>Node JS</p>
          <p>Express</p>
          <p>Git</p>
          <p>MongoDB</p>
          <p>SQL</p>
          <p>Firebase</p>
          <p>Jest - Testing</p>
        </div>

        <picture v-if="darkTheme">
          <source
            srcset="../assets/images/quote-2-white.webp"
            type="image/webp"
          />
          <source
            srcset="../assets/images/quote-2-white.png"
            type="image/jpeg"
          />
          <img
            class="quote-2"
            src="../assets/images/quote-2-white.png"
            alt="Quotes 2"
          />
        </picture>

        <picture v-if="!darkTheme">
          <source srcset="../assets/images/quote-2.webp" type="image/webp" />
          <source srcset="../assets/images/quote-2.png" type="image/jpeg" />
          <img
            class="quote-2"
            src="../assets/images/quote-2.png"
            alt="Quotes 2"
          />
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Skills',
  computed: {
    darkTheme() {
      return this.$store.state.darkTheme;
    },
  },
};
</script>

<style></style>
